import React, {useEffect, useState} from "react";
import InvoicesTable from './InvoicesTable'
import {useNavigate} from "react-router";


export default function InvoiceList(props) {
    const [data, setData] = useState({
        invoices: [],
        loading: true,
    });

    const navigate = useNavigate()

    useEffect(() => {
        document.title = 'Invoices'

        const token = sessionStorage.token
        if (!(token && token.length > 0)) {
            navigate("/login")
        }
        fetchData()
    }, [])

    const fetchData = async () => {
        var url = API_URL + '/api/private/tanker/v1/invoices'

        const token = sessionStorage.token
        if (!(token && token.length > 0)) navigate('/login')

        fetch(url, {headers: new Headers({'Authorization': `Bearer ${token}`})})
            .then(function (response) {
                if (response.status >= 400) {
                    throw new Error("Bad response from server");
                }
                return response.json();
            })
            .then(function (data) {
                setData({invoices: data, loading: false});
            });
    }
    return (
        <div>
            <InvoicesTable invoices={data.invoices}/>
        </div>
    )
}


